module.exports = __webpack_public_path__ + "static/media/454A9051.6d924219.jpg";